import React, { Component } from 'react'
import { Box, Button } from 'rebass'
import styled from 'styled-components'
import { Parallax } from 'react-scroll-parallax'
import { StaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'
import AspectRatio from 'react-aspect-ratio'

import Tiltable from '../components/Tiltable'

import LeftArrow from '../images/icons/left-arrow.svg'
import RightArrow from '../images/icons/right-arrow.svg'

const Wrap = styled(Box)`
  .gatsby-image-wrapper {
    height: 100%;
  }
`

const AcidImageWrap = styled(Box)`
  position: absolute;
  top: 85%;
  left: 5%;
  z-index: 10;
  display: none;
  @media (min-width: ${props => props.theme.breakpoints[0]}) {
    display: inline-flex;
  }
`

const query = graphql`
  query {
    acid: file(relativePath: { eq: "acid.jpg" }) {
      childImageSharp {
        fixed(width: 210, height: 210) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    one: file(relativePath: { eq: "slideshow/1.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1440) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    two: file(relativePath: { eq: "slideshow/2.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1440) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    three: file(relativePath: { eq: "slideshow/3.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1440) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    four: file(relativePath: { eq: "slideshow/4.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1440) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    five: file(relativePath: { eq: "slideshow/5.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1440) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    six: file(relativePath: { eq: "slideshow/6.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1440) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    seven: file(relativePath: { eq: "slideshow/7.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1440) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`

const SliderButton = styled(Button)`
  background: ${props => props.theme.colors.black};
  color: ${props => props.theme.colors.yellow};
  border-radius: 100%;
  width: 36px;
  height: 36px;
  align-items: center;
  justify-content: center;
  padding: 0;
  display: none;

  @media (min-width: ${props => props.theme.breakpoints[0]}) {
    display: flex;
  }

  &:focus {
    outline: 0;
  }

  svg {
    width: 14px;
    height: 14px;
  }
`
const ButtonWrap = styled(Box)`
  position: absolute;
  top: 50%;
  z-index: 20;
  ${props => props.side}: 16px;
`

class PictureSlideshow extends Component {
  constructor() {
    super()
    this.sliderRef = React.createRef()
  }

  state = {
    slider: null,
  }

  componentDidMount() {
    const Flickity = require('flickity')
    const slider = new Flickity(this.sliderRef.current, {
      autoPlay: 5000,
      pageDots: false,
      prevNextButtons: false,
      wrapAround: true,
      setGallerySize: false,
    })
    this.setState({ slider })
  }

  handlePrevious = () => {
    this.state.slider.previous()
  }

  handleNext = () => {
    this.state.slider.next()
  }

  render() {
    return (
      <StaticQuery
        query={query}
        render={data => (
          <Wrap css={{ position: 'relative' }}>
            <AspectRatio ratio={16 / 9}>
              <Box
                ref={this.sliderRef}
                css={{
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                }}
              >
                <Box width={1} css={{ height: '100%' }}>
                  <Img fluid={data.one.childImageSharp.fluid} />
                </Box>
                <Box width={1} css={{ height: '100%' }}>
                  <Img fluid={data.two.childImageSharp.fluid} />
                </Box>
                <Box width={1} css={{ height: '100%' }}>
                  <Img fluid={data.three.childImageSharp.fluid} />
                </Box>
                <Box width={1} css={{ height: '100%' }}>
                  <Img fluid={data.four.childImageSharp.fluid} />
                </Box>
                <Box width={1} css={{ height: '100%' }}>
                  <Img fluid={data.five.childImageSharp.fluid} />
                </Box>
                <Box width={1} css={{ height: '100%' }}>
                  <Img fluid={data.six.childImageSharp.fluid} />
                </Box>
                <Box width={1} css={{ height: '100%' }}>
                  <Img fluid={data.seven.childImageSharp.fluid} />
                </Box>
              </Box>
            </AspectRatio>
            <ButtonWrap side="left">
              <SliderButton onClick={this.handlePrevious}>
                <LeftArrow />
              </SliderButton>
            </ButtonWrap>
            <ButtonWrap side="right">
              <SliderButton onClick={this.handleNext}>
                <RightArrow />
              </SliderButton>
            </ButtonWrap>
            <AcidImageWrap>
              <Parallax y={[-20, 30]}>
                <Tiltable>
                  <Img
                    style={{
                      transform: 'rotate(-5deg)',
                      boxShadow: '0 0 15px 0 rgba(0,0,0,0.50)',
                    }}
                    fixed={data.acid.childImageSharp.fixed}
                  />
                </Tiltable>
              </Parallax>
            </AcidImageWrap>
          </Wrap>
        )}
      />
    )
  }
}
export default PictureSlideshow
